/* Display legacy combined sizes separately without changing Shopify variants. */
(() => {
  'use strict';
  if (window.RRProductSizeInseam) return;

  const instances = new Map();
  const observers = new Map();
  const pickerSelector = '[data-rr-product] .js-variants:not(.js-variants-quick-add), .o-main-collection-grid .js-variants-quick-add';
  const compare = (a, b) => a.localeCompare(b, 'en', { numeric: true });
  const parse = (value) => {
    const match = value.trim().match(/^(\d+(?:\.\d+)?|XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|[2-6]XL)\s*\/\s*(\d+(?:\.\d+)?)\s*(?:inches|inch|in\.?|["\u2033])(?:\s*\([^()]+\))?$/i);
    return match ? { size: match[1].toUpperCase(), inseam: String(Number(match[2])) } : null;
  };

  function enhance(picker) {
    if (instances.has(picker) || picker.dataset.type !== 'radio') return;
    const root = picker.closest('[data-rr-product]');
    const collection = picker.closest('.o-main-collection-grid');
    const isCollection = !!collection && picker.classList.contains('js-variants-quick-add');
    if (!isCollection && (!root || picker.dataset.section !== root.dataset.section)) return;
    const fields = [...picker.querySelectorAll('fieldset')];
    const names = fields.map((field) => {
      const legend = field.querySelector('legend')?.cloneNode(true);
      legend?.querySelectorAll('[data-selected-value], .rr-product__selected-option').forEach((item) => item.remove());
      return legend?.textContent.trim() || '';
    });
    if (names.some((name) => /\b(inseam|length)\b/i.test(name))) return;
    const sizeIndexes = names.flatMap((name, i) => /^size\s*:?[\s]*$/i.test(name) ? [i] : []);
    if (sizeIndexes.length !== 1) return;
    const index = sizeIndexes[0];
    const field = fields[index];
    const inputs = [...field.querySelectorAll('input[type="radio"]')];
    const entries = inputs.map((input) => ({ input, value: input.value, ...parse(input.value) }));
    if (!entries.length || entries.some((entry) => !entry.size)) return;
    if (new Set(entries.map((entry) => `${entry.size}|${entry.inseam}`)).size !== entries.length) return;

    let variants;
    try {
      variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
    } catch (_) { return; }
    if (!Array.isArray(variants) || !variants.length || variants.some((variant) =>
      !Array.isArray(variant.options) || variant.options.length !== fields.length ||
      !entries.some((entry) => entry.value === variant.options[index])
    )) return;
    if (fields.some((item) => !item.querySelector('input[type="radio"]:checked'))) return;

    const sizes = [...new Set(entries.map((entry) => entry.size))];
    const rank = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', '4XL', '5XL', '6XL'];
    sizes.sort((a, b) => rank.includes(a) && rank.includes(b) ? rank.indexOf(a) - rank.indexOf(b) : compare(a, b));
    const inseams = [...new Set(entries.map((entry) => entry.inseam))].sort(compare);
    const panel = document.createElement('div');
    panel.className = `rr-size-inseam${isCollection ? ' rr-size-inseam--collection' : ''}`;
    const buttons = { size: [], inseam: [] };
    for (const [kind, values, label] of [['size', sizes, 'Size'], ['inseam', inseams, 'Inseam']]) {
      const group = document.createElement('div');
      group.className = 'rr-size-inseam__group';
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', label);
      const heading = document.createElement('p');
      heading.className = 'rr-size-inseam__heading';
      heading.textContent = label;
      heading.setAttribute('aria-hidden', 'true');
      const row = document.createElement('div');
      row.className = 'rr-size-inseam__row';
      for (const value of values) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rr-size-inseam__button';
        button.dataset.kind = kind;
        button.dataset.value = value;
        button.textContent = kind === 'inseam' ? `${value}"` : value;
        button.setAttribute('aria-label', kind === 'inseam' ? `${value} inches` : `Size ${value}`);
        button.setAttribute('aria-pressed', 'false');
        buttons[kind].push(button);
        row.append(button);
      }
      group.append(heading, row);
      panel.append(group);
    }
    const status = document.createElement('span');
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    panel.append(status);

    const selectedEntry = () => entries.find((entry) => entry.input.checked);
    const availableEntries = () => {
      const selected = fields.map((item) => item.querySelector('input[type="radio"]:checked')?.value);
      const available = new Set(variants.filter((variant) => variant.available &&
        variant.options.every((value, i) => i === index || value === selected[i])
      ).map((variant) => variant.options[index]));
      return entries.filter((entry) => available.has(entry.value));
    };
    const chooseSize = (size, available = availableEntries()) => {
      const candidates = available.filter((entry) => entry.size === size);
      return candidates.find((entry) => entry.inseam === selectedEntry()?.inseam) ||
        candidates.sort((a, b) => compare(a.inseam, b.inseam))[0];
    };
    // Card shortcuts still send Nine the complete original option value.
    const preview = isCollection ? picker.closest('.rr-plp-card')?.querySelector('.rr-plp-card__sizes') : null;
    const opener = preview?.querySelector('button[data-rr-open]');
    const originalPreview = opener ? [...preview.childNodes] : null;
    const shortcuts = [];
    if (opener) {
      for (const size of sizes.slice(0, 5)) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = size;
        button.dataset.rrOpen = opener.dataset.rrOpen;
        button.dataset.option = field.dataset.option || 'size';
        button.setAttribute('aria-label', `Choose size ${size}`);
        shortcuts.push({ button, size });
      }
      preview.replaceChildren(...shortcuts.map((item) => item.button));
      if (sizes.length > 5) {
        const more = document.createElement('button');
        more.type = 'button';
        more.dataset.rrOpen = opener.dataset.rrOpen;
        more.textContent = `+${sizes.length - 5}`;
        more.setAttribute('aria-label', 'Choose from all sizes');
        preview.append(more);
      }
    }
    const refresh = () => {
      const selected = selectedEntry();
      const available = availableEntries();
      for (const [kind, items] of Object.entries(buttons)) {
        for (const button of items) {
          const value = button.dataset.value;
          button.setAttribute('aria-pressed', String(selected?.[kind] === value));
          button.disabled = !available.some((entry) => entry[kind] === value &&
            (kind === 'size' || entry.size === selected?.size));
          const original = entries.find((entry) => entry[kind] === value &&
            (kind === 'size' || entry.size === selected?.size));
          button.title = kind === 'inseam' && original ? original.value : button.getAttribute('aria-label');
        }
      }
      const message = selected ? `Selected: ${selected.value}` : '';
      if (status.textContent !== message) status.textContent = message;
      for (const { button, size } of shortcuts) {
        const entry = chooseSize(size, available);
        button.disabled = !entry;
        if (entry) button.dataset.size = entry.value;
        else delete button.dataset.size;
      }
    };
    const onClick = (event) => {
      const button = event.target.closest('.rr-size-inseam__button');
      if (!button || !panel.contains(button) || button.disabled) return;
      const selected = selectedEntry();
      const available = availableEntries();
      const kind = button.dataset.kind;
      const value = button.dataset.value;
      let target;
      if (kind === 'size') {
        target = chooseSize(value, available);
      } else {
        target = available.find((entry) => entry.size === selected?.size && entry.inseam === value);
      }
      if (!target || target.input.checked) return;
      target.input.checked = true;
      // Nine reads its original fieldsets and updates the real variant and cart ID.
      target.input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    panel.addEventListener('click', onClick);
    picker.addEventListener('change', refresh);
    refresh();
    field.after(panel);
    field.classList.add('rr-size-inseam__native');
    instances.set(picker, () => {
      panel.removeEventListener('click', onClick);
      picker.removeEventListener('change', refresh);
      panel.remove();
      field.classList.remove('rr-size-inseam__native');
      if (originalPreview) preview.replaceChildren(...originalPreview);
    });
  }

  function init(scope = document) {
    for (const [picker, destroy] of instances) {
      if (!picker.isConnected) { destroy(); instances.delete(picker); }
    }
    for (const [root, observer] of observers) {
      if (!root.isConnected) { observer.disconnect(); observers.delete(root); }
    }
    if (scope.matches?.(pickerSelector)) enhance(scope);
    scope.querySelectorAll(pickerSelector).forEach(enhance);
    const collections = [...scope.querySelectorAll('.o-main-collection-grid')];
    if (scope.matches?.('.o-main-collection-grid')) collections.push(scope);
    for (const collection of collections) {
      if (observers.has(collection)) continue;
      const observer = new MutationObserver((records) => {
        const hasPickers = (node) => node.nodeType === 1 &&
          (node.matches('.js-variants-quick-add') || node.querySelector('.js-variants-quick-add'));
        if (records.some((record) => [...record.addedNodes, ...record.removedNodes].some(hasPickers))) init(collection);
      });
      observer.observe(collection, { childList: true, subtree: true });
      observers.set(collection, observer);
    }
  }
  window.RRProductSizeInseam = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [root, observer] of observers) {
      if (event.target.contains(root)) { observer.disconnect(); observers.delete(root); }
    }
    for (const [picker, destroy] of instances) {
      if (event.target.contains(picker)) { destroy(); instances.delete(picker); }
    }
  });
})();
